/**
 * Wraps main app content and reserves space for Mojo Agent when using push layout.
 */
import React, { type ReactNode } from 'react';
import { useMojoAgent } from '../../contexts/MojoAgentContext';
import { MojoAgentShell } from './MojoAgentShell';

interface MojoAgentLayoutProps {
  children: ReactNode;
}

export function MojoAgentLayout({ children }: MojoAgentLayoutProps): React.ReactElement {
  const { compactNavigation: usePushLayout } = useMojoAgent();

  return (
    <div
      data-mojo-push={usePushLayout ? 'true' : undefined}
      className={`flex flex-1 min-h-screen flex-col ${
        usePushLayout ? 'lg:flex-row lg:items-stretch lg:min-h-0 lg:overflow-hidden' : ''
      }`}
    >
      <div className="flex w-full min-w-0 max-w-full flex-1 flex-col overflow-x-hidden">{children}</div>
      <MojoAgentShell />
    </div>
  );
}
